import { RealSlot } from "@/components/slot/RealSlot";
import { SlotSymbol } from "@/components/slot/SlotSymbol";

const SLOT_PAYS = [[9, 19, 47], [9, 23, 56], [14, 33, 70], [28, 70, 170], [42, 130, 350], [85, 350, 1700]];
const BONUS_PAYS = [[4, 8, 20], [4, 10, 24], [6, 14, 30], [12, 30, 70], [18, 55, 150], [36, 150, 700]];

export const SlotGame = ({ game, mode }) => {
  const isBonus = game.type === "bonus";
  const pays = isBonus ? BONUS_PAYS : SLOT_PAYS;
  return (
    <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 items-start [&>*]:min-w-0">
      <RealSlot game={game} mode={mode} />
      <div className="rounded-3xl border border-white/10 bg-[#111]/90 backdrop-blur-xl p-6 sm:p-8" data-testid="paytable">
        <h2 className="font-display font-bold text-xl mb-1">Ödəniş cədvəli</h2>
        <p className="text-xs text-zinc-500 mb-6">Xətt mərcinin əmsalı · soldan ardıcıl 3/4/5 eyni simvol · RTP ~95%</p>
        {isBonus && (
          <div className="flex items-center gap-4 rounded-xl bg-[#c4112f]/15 border border-[#c4112f]/40 px-4 py-3 mb-4" data-testid="bonus-rule">
            <div className="w-14 h-14 flex items-center justify-center"><SlotSymbol name="scatter" /></div>
            <p className="text-sm"><span className="font-bold text-[#FFD700]">3 BONUS</span> simvolu = <span className="font-bold">10 pulsuz fırlatma</span>. Mərc: 0.40 – 20 ₼</p>
          </div>
        )}
        <div className="space-y-2.5">
          {game.symbols.map((s, i) => ({ s, p: pays[i] })).reverse().map(({ s, p }) => (
            <div key={s} className="flex items-center gap-4 rounded-xl bg-black/40 border border-white/5 px-4 py-2">
              <div className="w-12 h-12 flex items-center justify-center"><SlotSymbol name={s} size={32} /></div>
              <div className="flex-1 grid grid-cols-3 text-center text-sm">
                {p.map((v, k) => <div key={k}><span className="text-zinc-500 text-xs">{k + 3}x </span><span className="font-semibold text-[#FFD700]">x{v}</span></div>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
